import { render } from "./AccessxTables.vue?vue&type=template&id=d36268a0"
import script from "./AccessxTables.vue?vue&type=script&lang=js"
export * from "./AccessxTables.vue?vue&type=script&lang=js"

import "./AccessxTables.vue?vue&type=style&index=0&id=d36268a0&lang=css"

import exportComponent from "/Users/aml/Projects/dashboardcopy2/fnbxv21-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__